import { createEvent, createEffect, sample } from 'effector';
import { AIServiceAgentCategoryDto } from '@internal/nimbus-ai';
import { aiServiceCommonApiClient } from '@nx-frontend/shared/next-api/proxy/clients';
// eslint-disable-next-line no-restricted-imports
import { $currentWorkspace } from '../current-workspace';
import { $aiAgentCategories } from './ai-agent-categories-store';

export const aiAgentCategoriesFetchCategoriesEvent = createEvent<void>();

const aiAgentCategoriesFetchCategoriesFx = createEffect<{ orgId: string }, AIServiceAgentCategoryDto[]>(
  async ({ orgId }) => {
    const categories = await aiServiceCommonApiClient.AgentApi.apiGetAgentCategories(
      {
        org: orgId,
        withCount: true,
      },
      { withCredentials: true }
    );
    return categories.data;
  }
);

sample({
  source: { currentWorkspace: $currentWorkspace },
  clock: aiAgentCategoriesFetchCategoriesEvent,
  fn: ({ currentWorkspace }) => {
    return { orgId: currentWorkspace?.orgId };
  },
  target: aiAgentCategoriesFetchCategoriesFx,
});

$aiAgentCategories.on(aiAgentCategoriesFetchCategoriesFx.doneData, (state, categories) => {
  return {
    ...state,
    categories,
  };
});
